export const  findValue=(list, path)=> {
    // 每次进来使用find遍历一次
	let res = list.find((item) => item.path == path);
    if (res) {
		return res;
	} else {
		for (let i = 0; i < list.length; i++) {
			if (list[i].children instanceof Array && list[i].children.length > 0) {
				res = findValue(list[i].children, path);
				
				if (res) return res;
			}
		}
		
		return null;
	}
    
}




// WEBPACK FOOTER //
// ./src/utils/pawer.js